import {
  $albumsTableSearchInputValue,
  AlbumsTable,
  AlbumsTableFiltersMenu,
  AlbumsTableGate,
  albumsTableQuery,
  albumsTableSearchChanged,
} from '@/entities/albums'
import { ROUTES, STRINGS } from '@/shared/config'
import { EmptyContent, HidingSpin } from '@/shared/ui'
import { FilterOutlined, PlusOutlined, SearchOutlined } from '@ant-design/icons'
import { Button, Flex, Input, Popover, Space } from 'antd'
import { useUnit } from 'effector-react'
import { NavLink, useNavigate } from 'react-router-dom'

import type { AuthorEditorTabProps } from '..'

export const AuthorAlbumsTab = ({ author }: AuthorEditorTabProps) => {
  const navigate = useNavigate()

  const { data, pending, error } = useUnit(albumsTableQuery)

  const search = useUnit($albumsTableSearchInputValue)
  const changeSearch = useUnit(albumsTableSearchChanged)

  return (
    <>
      <AlbumsTableGate initialFilters={{ AuthorIds: [author.id] }} />
      <Flex justify="end" align="center" style={{ marginBottom: 24 }}>
        <Space>
          <Popover
            content={<AlbumsTableFiltersMenu />}
            title={STRINGS.label_filters_control}
            trigger="click"
            placement="bottom"
            destroyOnHidden
          >
            <Button icon={<FilterOutlined />}>
              {STRINGS.label_filters_control}
            </Button>
          </Popover>
          <Input
            placeholder={STRINGS.placeholder_search_by_name_input}
            allowClear
            addonAfter={<SearchOutlined />}
            value={search || ''}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              const searchString = event.target.value
              changeSearch(searchString)
            }}
            style={{
              minWidth: 300,
            }}
          />
          <NavLink
            to={ROUTES.COLLECTIONS.CREATE_ALBUM}
            state={{ author: author }}
          >
            <Button icon={<PlusOutlined />}>Создать</Button>
          </NavLink>
        </Space>
      </Flex>
      <HidingSpin spinning={pending || (!data?.items && !error)}>
        {data?.items && data.items.length > 0 ? (
          <AlbumsTable
            onEdit={(albumId: string) => {
              void navigate(
                ROUTES.COLLECTIONS.EDIT_ALBUM.replace(':id', albumId),
                { state: { author: author } },
              )
            }}
          />
        ) : search?.length && search?.length > 0 ? (
          <EmptyContent description={STRINGS.nothing_was_found} />
        ) : (
          <EmptyContent
            description="В списке пока нет ни одного альбома"
            content={
              <Space>
                <NavLink
                  to={ROUTES.COLLECTIONS.CREATE_ALBUM}
                  state={{ author: author }}
                >
                  <Button color="purple" variant="solid">
                    Создать альбом
                  </Button>
                </NavLink>
              </Space>
            }
          />
        )}
      </HidingSpin>
    </>
  )
}
